import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGrid, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import {
   DropdownMenu,
   DropdownMenuContent,
   DropdownMenuItem,
   DropdownMenuTrigger,
} from '@ifixit/ui/components/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { cn } from '@ifixit/ui/lib/utils';
import { TiptapButton, tiptapButtonClassName } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { _js } from '@ifixit/localize';

const gridModes = {
   columns: _js('Columns'),
   rows: _js('Rows'),
};

const GridToggleButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleGrid(null).run()}
         isActive={editor.isActive('grid')}
         isDisabled={!editor.can().toggleGrid(null)}
         icon={<FontAwesomeIcon icon={faGrid} />}
         title={_js('Insert grid layout')}
      />
   );
};

export function GridDropdown() {
   return (
      <div className="inline-flex">
         <GridToggleButton />
         <GridDropdownMenu />
      </div>
   );
}

function GridDropdownMenu() {
   const { editor } = useEditorContext();
   const label = _js('Choose grid layout');

   const handleOpenChange = (open: boolean) => {
      if (!open) {
         setTimeout(() => editor.commands.focus(), 50);
      }
   };

   return (
      <Tooltip>
         <DropdownMenu onOpenChange={handleOpenChange}>
            <TooltipTrigger asChild>
               <DropdownMenuTrigger asChild>
                  <button type="button" aria-label={label} className={cn(tiptapButtonClassName)}>
                     <FontAwesomeIcon icon={faChevronDown} />
                  </button>
               </DropdownMenuTrigger>
            </TooltipTrigger>
            <DropdownMenuContent align="start">
               {Object.entries(gridModes).map(([mode, modeLabel]) => {
                  const columns = mode === 'columns' ? 2 : null;
                  const onSelectHandler = editor.isActive('grid')
                     ? () => editor.chain().focus().setGridMode(columns).run()
                     : () => editor.chain().focus().toggleGrid(columns).run();
                  return (
                     <DropdownMenuItem key={mode} onSelect={onSelectHandler}>
                        {modeLabel}
                     </DropdownMenuItem>
                  );
               })}
            </DropdownMenuContent>
         </DropdownMenu>
         <TooltipContent side="top" align="start">
            {label}
         </TooltipContent>
      </Tooltip>
   );
}
